module.exports = __webpack_public_path__ + "static/media/fulltime_argentina.95d25230.png";